export default "__VITE_ASSET__BozFXs4U__"